export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6Le4Pn8tAAAAAO_AaOwdl1Awv12_hxelu2pIz3UU',
  },

   // baseUrl: 'https://localhost:7249/api/'
   baseUrl: 'https://www.email.canogaparkclassaction.com/api/'
  // baseUrl: 'https://canogaparkclassaction-dev-fxgne9h5gwbggdg3.centralus-01.azurewebsites.net/api/'

};

